import React from 'react';

import { DivisionDto } from 'src/api/FiretrolApiClient';
import { useOrganization } from 'src/hooks/useOrganization';
import { PersistentSelect } from 'src/design/atoms/PersistentSelect';

interface IDivisionSelectorProps {
  onChange: (divisions: DivisionDto[]) => void;
  hideLabel?: boolean;
  value?: DivisionDto[];
}

export const DivisionSelector: React.FC<IDivisionSelectorProps> = ({
  onChange,
  value = [],
  hideLabel = false,
}) => {
  const { divisions } = useOrganization();

  return (
    <PersistentSelect
      options={divisions}
      value={value}
      onChange={onChange}
      placeholder="Search divisions"
      inputProps={{
        label: hideLabel ? undefined : 'Divisions',
      }}
      emptyMessage="No divisions found..."
      getOptionId={(option) => option.id}
      getOptionLabel={(option) => option.name}
    />
  );
};
